import { MailOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Card, Form, Input, Select, Typography, message } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  addAopsMember,
  getSalusUserGroupList,
} from '../../api/electronicApproval.api'
import './addAopsMember.scss'
import Swal from 'sweetalert2'

const { Title } = Typography
const { Option } = Select

const AddAopsMember = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [groupList, setGroupList] = useState([])

  useEffect(() => {
    const fetchSalusUserGroupList = async () => {
      try {
        const res = await getSalusUserGroupList()
        console.log('Salus user group list:', res)
        if (res && Array.isArray(res)) {
          setGroupList(res)
        }
      } catch (error) {
        console.error('Error fetching salus user group list:', error)
        message.error('그룹 목록을 불러오는데 실패했습니다.')
      }
    }
    fetchSalusUserGroupList()
  }, [])

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      await handleAddAopsMember(values)
      message.success('멤버가 성공적으로 추가되었습니다!')
      form.resetFields()
    } catch (error) {
      message.error('멤버 추가에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  const handleAddAopsMember = async (values) => {
    // 선택한 groupId로 groupList에서 해당 그룹 찾기
    const selectedGroup = groupList.find(
      (group) => group.teamId === values.groupId,
    )

    if (!selectedGroup) {
      message.error('선택한 그룹 정보를 찾을 수 없습니다.')
      throw new Error('Group not found')
    }

    const param = {
      name: values.name,
      email: values.email,
      studioGroupId: selectedGroup.studioId,
      teamGroupId: selectedGroup.teamId,
    }
    try {
      const res = await addAopsMember(param)
      console.log('Aops member added:', res)
      Swal.fire({
        title: '멤버 추가 완료',
        text: `비밀번호는 ${res.password} 입니다.`,
        icon: 'success',
      })
    } catch (error) {
      console.error('Error adding aops member:', error)
      throw error
    }
  }

  return (
    <div className="add-aops-member-container">
      <Card className="member-form-card">
        <div className="form-header">
          <TeamOutlined className="header-icon" />
          <Title level={3} className="form-title">
            새 멤버 추가
          </Title>
          <p className="form-description">
            팀에 새로운 멤버를 초대하여 협업을 시작하세요
          </p>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="member-form"
          requiredMark={false}
        >
          <Form.Item
            label="이름"
            name="name"
            rules={[
              { required: true, message: '이름을 입력해주세요' },
              { min: 2, message: '이름은 최소 2자 이상이어야 합니다' },
              { max: 50, message: '이름은 최대 50자까지 입력 가능합니다' },
              {
                pattern: /^[a-zA-Z가-힣\s]+$/,
                message: '이름은 한글, 영문만 입력 가능합니다',
              },
              {
                whitespace: true,
                message: '공백만 입력할 수 없습니다',
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="input-icon" />}
              placeholder="홍길동"
              size="large"
              className="custom-input"
            />
          </Form.Item>

          <Form.Item
            label="이메일"
            name="email"
            rules={[
              { required: true, message: '이메일을 입력해주세요' },
              { type: 'email', message: '올바른 이메일 형식이 아닙니다' },
              {
                whitespace: true,
                message: '공백만 입력할 수 없습니다',
              },
            ]}
          >
            <Input
              prefix={<MailOutlined className="input-icon" />}
              placeholder="example@company.com"
              size="large"
              className="custom-input"
            />
          </Form.Item>

          <Form.Item
            label="그룹"
            name="groupId"
            rules={[{ required: true, message: '그룹을 선택해주세요' }]}
          >
            <Select
              placeholder="그룹을 선택하세요"
              size="large"
              className="custom-select"
              loading={groupList.length === 0}
            >
              {groupList.map((group) => (
                <Option key={group.teamId} value={group.teamId}>
                  {group.studioKo} - {group.teamKo}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className="submit-button-container">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              className="submit-button"
              block
            >
              멤버 추가하기
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default AddAopsMember
